import {
  AUTH_IN, AUTH_OUT, AUTH_UPDATE, AUTH_UPDATE_TOKEN, getAction,
} from './type.actions';

export const SignInAction = (user) => getAction(AUTH_IN, user);
export const UpdateUserAction = (user) => getAction(AUTH_UPDATE, user);
export const UpdateTokenAction = (token) => getAction(AUTH_UPDATE_TOKEN, token);
export const LogoutAction = () => getAction(AUTH_OUT);
